export default __webpack_public_path__ + "static/media/bbamUSD.33e9ebbe.png";